module.exports = __webpack_public_path__ + "static/media/baseline-assignment_turned_in-24px.0435ebba.svg";